import { InputAdornment } from "@deere/fuel-react";
import EventIcon from "@mui/icons-material/Event";
import dayjs, { Dayjs } from "dayjs";
import { useTranslation } from "react-i18next";
import DateRangePicker from "../../../../components/DatePickers/DateRangePicker/DateRangePicker";
import { dayJSLang } from "../../../../types";

const InvoicesDateRangePicker = ({
  startDate,
  endDate,
  onDateRangeChange,
  minDate,
  disabled,
}: {
  startDate: Dayjs;
  endDate: Dayjs;
  onDateRangeChange: (startDate: Dayjs, endDate: Dayjs) => void;
  minDate: Dayjs;
  disabled: boolean;
}) => {
  const {
    i18n: { language },
  } = useTranslation();

  function applyLocale(date: Dayjs) {
    const locale = dayJSLang[language];
    return date.locale(locale);
  }

  const dateRangePickerSx = {
    fontSize: ".875rem",
    fontWeight: 400,
    lineHeight: "1.4375em",
  };

  return (
    <DateRangePicker
      value={[applyLocale(startDate), applyLocale(endDate)]}
      dateRangeCalendarProps={{
        minDate,
        maxDate: dayjs(),
      }}
      onChange={(selection) => {
        const [from, to] = selection;
        onDateRangeChange(from, to);
      }}
      label=""
      enableShortcuts
      textFieldProps={{
        disabled,
        InputProps: {
          sx: dateRangePickerSx,
          startAdornment: (
            <InputAdornment position="start">
              <EventIcon style={{ width: "20px", height: "20px" }} />
            </InputAdornment>
          ),
        },
      }}
      resetConfig={{
        days: 30,
        months: 0,
      }}
    />
  );
};

export default InvoicesDateRangePicker;
